<template>
    <rkm-modal
        ref="Modal"
        title="Opções de impressão"
        persistent
        @close="reset"
        @cancel="reset"
        @hide="reset"
    >
        <template v-if="form.agendamento.length > 0">
            <h6>Agendamento de exames</h6>

            <rkm-form-checkbox
                v-if="form.agendamento.length > 1"
                v-model="model.selectAllAgendamento"
                :disabled="disabledSelectAllAgendamento"
            >
                Todos
            </rkm-form-checkbox>

            <rkm-form-checkbox-group
                :options="form.agendamento"
                v-model="model.agendamento"
                stacked
            />
        </template>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                color="primary"
                :disabled="!anyItemChecked"
                @click="print"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { repository, error } from '@/mixins'

// Utils.
import etiqueta from '@/utils/exame-laboratorial/impressao/etiqueta'
import protocolo from '@/utils/exame-laboratorial/impressao/protocolo'

// Moment.
import moment from 'moment'

// Filters.
import formats from '@/filters/formats'

export default {
    computed: {
        ...mapGetters({
            cliente: 'getCliente',
            lotacao: 'getLotacao',
            customer: 'getCustomer',
         }),
        anyItemChecked() {

            return this.model.agendamento.length > 0
        },
        disabledSelectAllAgendamento() {

            return !this.form.agendamento.find(i => !i.disabled)
        },
    },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
        }
    },
    data: () => ({
        atendimentoId: null,
        form: {
            agendamento: [],
        },
        model: {
            selectAllAgendamento: false,
            agendamento: [],
        },
        utils: { etiqueta, protocolo },
        callbackOnClose: null,
        dataEntrega: null
    }),
    filters: {
        ...formats,
    },
    mixins: [repository, error],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(impressoes, atendimentoId, callbackOnClose = null) {

            this.handleEntrega(impressoes.agendamento.find(agendamento => agendamento.value == 'protocolo').data)

            impressoes.agendamento.find(agendamento => agendamento.value == 'protocolo').data.dataEntrega = this.dataEntrega

            this.form.agendamento = impressoes.agendamento || []

            this.atendimentoId = atendimentoId
            this.callbackOnClose = callbackOnClose

            this.$refs.Modal.show()
        },
        handleEntrega(agendamento) {

            let prazoEntrega = null

            agendamento.examesIncluidos.forEach(exame => {

                if (exame.prazoEntrega !== null) {

                    if (prazoEntrega == null) {

                        prazoEntrega = exame.prazoEntrega
                    } else {

                        if (prazoEntrega < exame.prazoEntrega) {

                            prazoEntrega = exame.prazoEntrega
                        }
                    }
                }
            })

            if (prazoEntrega !== null) {

                this.dataEntrega = moment(agendamento.dataEntrega).add(prazoEntrega, 'days').format('DD/MM/YYYY')
            } else {

                this.dataEntrega = ''
            }
        },
        print() {

            this.model.agendamento.forEach(i => this.downloadAgendamento(i))
        },
        downloadAgendamento(item) {


            switch (item) {

                case 'etiqueta': {

                    this.utils.etiqueta.print({
                        ...this.form.agendamento.find(i => i.value === 'etiqueta').data,
                        unidadeLogada: this.lotacao.infraestrutura.nome,
                    })

                    break
                }
                case 'protocolo': {

                    this.utils.protocolo.print({
                        ...this.form.agendamento.find(i => i.value === 'protocolo').data,
                        cliente: this.cliente.nome,
                        usuarioLogado: this.lotacao.usuario.nome,
                        logotipo: this.customer.logotipo
                    })

                    break
                }
            }
        },
        openFile(repository) {

            this.setLoading()

            repository()
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form.agendamento = []

            this.model.agendamento = []

            this.model.selectAllAgendamento = false
            this.model.selectAllMedicoEnfermagem = false

            if (typeof this.callbackOnClose === 'function') {

                this.callbackOnClose()
            }
        }
    },
    watch: {
        'model.selectAllAgendamento': function (selectAll) {

            this.model.agendamento = selectAll
                ? this.form.agendamento.filter(i => !i.disabled).map(i => i.value)
                : []
        },
    }
}
</script>